import StatsPanel from './StatsPanel.js';
export default StatsPanel;
//# sourceMappingURL=index.js.map